// src/components/profile/ProfileField.jsx

import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { useProfileStyles } from './profileStyles';

const ProfileField = ({
  label,
  value,
  icon: Icon,
}) => {
  const classes = useProfileStyles();

  return (
    <Box className={classes.fieldRow}>
      {Icon && <Icon className={classes.fieldIcon} />}

      <Typography variant="body2" className={classes.fieldLabel}>
        {label}
      </Typography>

      <Typography variant="body2" className={classes.fieldValue}>
        {value || '-'}
      </Typography>
    </Box>
  );
};

export default ProfileField;